import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { LazyImage } from '~/components/LazyImage';
import { tiktokType } from '~/types';

const propTypes = {
  content: tiktokType,
  alt: PropTypes.string,
  contentPreviewedId: PropTypes.string,
};

const TIKTOK_PREVIEW_ASPECT_RATIO = 16 / 27;

export const TiktokPreviewCard = ({
  alt = 'Tiktok video preview',
  content,
  contentPreviewedId,
}) => {
  const [asset] = content.assets ?? [];
  return (
    <Box borderRadius="lg" overflow="hidden">
      <LazyImage
        ratio={TIKTOK_PREVIEW_ASPECT_RATIO}
        src={asset?.previewUrl}
        imageProps={{ alt, id: contentPreviewedId }}
      />
    </Box>
  );
};

TiktokPreviewCard.propTypes = propTypes;
